import useAuth from "@hooks/useAuth"
import { useEffect, useMemo, useRef } from "react"

export default function useHooks(
    salon: Model.Response<Customer.Resources.Salon>, 
    api: Customer.Models.Salon.Api, 
    methods: Customer.Models.Salon.Methods,
    actions: Customer.Models.Salon.Actions
): Customer.Models.Salon.Hooks {
    const participateIfCurrent = useMemo(() => getParticipateIfCurrentHook(salon, actions), [salon])

    return {
        participateIfCurrent
    }
}

function getParticipateIfCurrentHook(
    salon: Model.Response<Customer.Resources.Salon>, 
    actions: Customer.Models.Salon.Actions
): Customer.Models.Salon.Hooks.ParticipateIfCurrent {
    return () => {
        const sent = useRef(false)
        const { setUser } = useAuth<Resources.Customer>()

        useEffect(() => {
            if (!salon.data) return
            if (sent.current) return
            if (salon.data.status !== "current") return

            sent.current = true
            actions.participate()
                .then(() => {
                    setUser(old => ({ 
                        ...old, 
                        participating_count: old.participating_count + 1, 
                        current_count: old.current_count - 1 
                    }))
                })
        }, [salon.data?.status])
    }
}